const trimTrailingSlash = (value = "") => String(value).replace(/\/+$/, "");

const normalizePath = (path = "") => (path.startsWith("/") ? path : `/${path}`);

const serverBase =
  trimTrailingSlash(process.env.REACT_APP_SUPPORTTICKET_SERVER) ||
  trimTrailingSlash(process.env.REACT_APP_SKALEBOT_SERVER);

const defaultBrowserBase =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : "";

const socketBase =
  trimTrailingSlash(process.env.REACT_APP_SUPPORTTICKET_SOCKET_SERVER) ||
  trimTrailingSlash(process.env.REACT_APP_SUPPORTTICKET_SERVER) ||
  trimTrailingSlash(process.env.REACT_APP_SKALEBOT_SERVER) ||
  trimTrailingSlash(defaultBrowserBase);

export const getSupportticketApiUrl = (path) =>
  `${serverBase}/api/v1${normalizePath(path)}`;

export const getSupportticketSocketUrl = (namespace = "") =>
  `${socketBase}${normalizePath(namespace)}`;
